import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Footer from "./components/Footer";
import Contact from "./components/pages/ContactPageNew";
import ActivitiesPage from "./components/pages/ActivitiesPage";
import Statistics from "./components/home-sections/StatisticsSection";
import ScrollToTop from "./components/ScrollToTop";
import AboutPage from "./components/pages/AboutPage";
import VideoSection from "./components/home-sections/VideoSection";
import ActivitiesSectionNew from "./components/home-sections/ActivitiesSectionNew";
import "./styles/NeonButton.css";
import AnnouncementPage from "./components/pages/AnnouncementPage";
import NextJourney from "./components/pages/NextJourney";
import CuidadosPage from "./components/pages/CuidadosPage";

function App() {
  return (
    <Router>
      <ScrollToTop />{" "}
      {/* Colocarlo dentro del Router para que funcione correctamente */}
      <div className="App">
        {/* <AlertBanner /> */}
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <Statistics />
                <VideoSection />
                <ActivitiesSectionNew />
              </>
            }
          />
          <Route path="/asociacion" element={<AboutPage />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/actividades" element={<ActivitiesPage />} />
          <Route path="/proxima-edicion-camino" element={<NextJourney />} />
          <Route path="/recomendaciones-autocuidado" element={<CuidadosPage />} />
          <Route
            path="/concierto-solidario-14-marzo"
            element={<AnnouncementPage />}
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
